<template>
  <setup-league-game />
</template>

<script>
import SetupLeagueGame from "../components/SetupLeagueGame.vue"

export default {
  name: "LeagueGameStart",
  components: {
    SetupLeagueGame
  },
};
</script>
